module.exports = __webpack_public_path__ + "static/media/home-road-dropoff-xlarge_2x.4ba8b886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-road-dropoff-xlarge_2x.png
// module id = 1532
// module chunks = 27